var installedModules = {};
var moduleToHandlerMapping = {
	52598: {
		getter: () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	88186: {
		getter: () => (__webpack_require__.e(342).then(() => (() => (__webpack_require__(40961))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	15843: {
		getter: () => (Promise.all([__webpack_require__.e(799), __webpack_require__.e(445), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(7799))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@pflm-shared",
	},
	29332: {
		getter: () => (Promise.all([__webpack_require__.e(443), __webpack_require__.e(445)]).then(() => (() => (__webpack_require__(93443))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx-react-lite",
	},
	99733: {
		getter: () => (__webpack_require__.e(996).then(() => (() => (__webpack_require__(93996))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.8.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	37445: {
		getter: () => (__webpack_require__.e(813).then(() => (() => (__webpack_require__(27813))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.13.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx",
	},
	40689: {
		getter: () => (Promise.all([__webpack_require__.e(985), __webpack_require__.e(71)]).then(() => (() => (__webpack_require__(13985))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.85.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query-persist-client",
	},
	2071: {
		getter: () => (__webpack_require__.e(946).then(() => (() => (__webpack_require__(43946))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.85.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"71": [
		2071
	],
	"186": [
		88186
	],
	"445": [
		37445
	],
	"598": [
		52598
	],
	"689": [
		40689
	],
	"795": [
		15843,
		29332,
		99733
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}